import type { TFunction } from 'i18next';
import { BonusShopProductType } from '@/api/cms/bonusShop';
import type { BonusShopProduct } from '../../types';

export interface ResultContent {
  title: string;
  subtitle: string;
  action: string;
  withProduct: boolean;
  withAmount: boolean;
  productNote?: string;
}

const ACTIVATABLE_TYPES = [
  BonusShopProductType.FREE_SPINS,
  BonusShopProductType.CASH_BONUS,
];

export const getErrorContent = (t: TFunction): ResultContent => ({
  title: t('result.errorTitle'),
  subtitle: t('result.errorSubtitle'),
  action: t('result.tryAgain'),
  withProduct: false,
  withAmount: false,
});

export const getSuccessContent = (
  product: BonusShopProduct,
  t: TFunction
): ResultContent => {
  if (ACTIVATABLE_TYPES.includes(product.type))
    return {
      title: t('result.successTitle'),
      subtitle: t('result.activateSubtitle'),
      action: t('result.activateAction'),
      withProduct: true,
      withAmount: false,
    };

  const isPremium = product.type === BonusShopProductType.PREMIUM;

  return {
    title: t('result.successTitle'),
    subtitle: t('result.creditedSubtitle'),
    action: t('result.gotIt'),
    withProduct: isPremium,
    withAmount: true,
    productNote: isPremium
      ? t('result.premiumNote', { title: product.title })
      : undefined,
  };
};
